import { supabase } from '../lib/supabase';

// Convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = toCamelCase(obj?.[key]);
    return acc;
  }, {});
};

// Convert camelCase to snake_case
const toSnakeCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, (letter) => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = toSnakeCase(obj?.[key]);
    return acc;
  }, {});
};

export const newsletterService = {
  async getAllSubscribers() {
    const { data, error } = await supabase
      ?.from('newsletter_subscribers')
      ?.select('*')
      ?.order('subscribed_at', { ascending: false });

    if (error) throw error;
    return toCamelCase(data);
  },

  async getActiveSubscribers() {
    const { data, error } = await supabase
      ?.from('newsletter_subscribers')
      ?.select('*')
      ?.eq('is_active', true)
      ?.order('subscribed_at', { ascending: false });

    if (error) throw error;
    return toCamelCase(data);
  },

  async deleteSubscriber(id) {
    const { error } = await supabase
      ?.from('newsletter_subscribers')
      ?.delete()
      ?.eq('id', id);

    if (error) throw error;
  },

  async toggleSubscriberStatus(id, isActive) {
    const updateData = {
      is_active: isActive,
      unsubscribed_at: isActive ? null : new Date()?.toISOString()
    };

    const { data, error } = await supabase
      ?.from('newsletter_subscribers')
      ?.update(toSnakeCase(updateData))
      ?.eq('id', id)
      ?.select()
      ?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async exportSubscribers() {
    const subscribers = await this.getActiveSubscribers();
    
    // Create CSV content
    const headers = ['Email', 'Subscribed Date', 'Status'];
    const rows = subscribers?.map(sub => [
      sub?.email,
      new Date(sub?.subscribedAt)?.toLocaleDateString(),
      sub?.isActive ? 'Active' : 'Inactive'
    ]);

    const csvContent = [
      headers?.join(','),
      ...rows?.map(row => row?.join(','))
    ]?.join('\n');

    // Create download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link?.setAttribute('href', url);
    link?.setAttribute('download', `newsletter-subscribers-${new Date()?.toISOString()?.split('T')?.[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);

    return subscribers?.length;
  }
};